// extracted by mini-css-extract-plugin
export default {"loader":"index_loader__6t6sc","dot":"index_dot__xNOzz","dotter":"index_dotter__YeECe","glow":"index_glow__zM2eL"};